<template>
	<div id="app"
		:class="{isDesktopA: !isMobile && !showBoletoB,
				 isDesktopB: !isMobile && showBoletoB,
				 isMobileA: isMobile && !showBoletoB,
				 isMobileB: isMobile && showBoletoB}">
				 
			<BoletoDesktopA v-if="!isMobile && !boletonotfound && !showBoletoB /*&& !boletovencido && !boletopago*/" />
			<BoletoDesktopB v-else-if="!isMobile && !boletonotfound && showBoletoB /*&& !boletovencido && !boletopago*/" />
			
			<BoletoMobileA v-if="isMobile  && !boletonotfound && !showBoletoB /*&& !boletovencido && !boletopago*/" />
			<BoletoMobileB v-else-if="isMobile && !boletonotfound && showBoletoB /*&& !boletovencido && !boletopago*/" />

			<div v-if="boletonotfound">
				<BoletoNotFound />
			</div>
			<div v-if="boletodeadlock">
				<a class="linkretryboleto" @click="retryOpenBoleto">Erro ao carregar o boleto. Clique aqui para tentar novamente.</a>
			</div>

			<!--
			<div v-if="boletovencido">
				Boleto vencido.
			</div>
			<div v-if="boletopago">
				Boleto pago.
			</div>
			-->
		
	</div>
</template>

<style lang="scss">
	@import '@/assets/css/app.scss';
	@import '@/assets/css/helper.scss';
	
	@import '@/assets/css/boletoLayoutClassico.scss';
	@import '@/assets/css/boletoDesktopA.scss';
	@import '@/assets/css/boletoDesktopB.scss';
	
	@import '@/assets/css/boletoMobileA.scss';
	@import '@/assets/css/boletoMobileB.scss';
	
	@import '@/assets/css/print.scss';
</style>

<script>
import BoletoDesktopA 	from './components/BoletoDesktopA.vue'
import BoletoDesktopB	from './components/BoletoDesktopB.vue'
import BoletoMobileA 	from './components/BoletoMobileA.vue'
import BoletoMobileB 	from './components/BoletoMobileB.vue'
import BoletoNotFound 	from './components/BoletoNotFound.vue'

import { mapState, mapMutations, mapActions } from 'vuex'
export default {
	name: 'app',
	components: {
		BoletoDesktopA,
		BoletoDesktopB,
		BoletoMobileA,
		BoletoMobileB,
		BoletoNotFound
	},

	mounted: function(){
		let self = this;
		
		document.title = "Boleto Bancário";
		this.$store.commit("boleto/setIsMobile", [true]);
		
		this.$store.dispatch("boleto/getBoleto", []).then(
			() => {
				this.$store.commit('boleto/sendPostIframe');
				//this.$store.dispatch('boleto/tryRegistro', self.boleto_padrao);
			}
		);
		
		
		
		
	},

	computed:{
		isMobile: function(){
			return this.$store.state.boleto.isMobile;
		},
		
		showBoletoB: function(){
			return this.$store.state.boleto.showBoletoB;
		},

		boletonotfound: function(){
			return this.$store.state.boleto.boletonotfound;
		},

		boleto_padrao: function(){
			return this.$store.state.boleto.boleto_padrao;
		},

		boletodeadlock: function(){
			return this.$store.state.boleto.boletodeadlock;
		},

		boletovencido: function(){
			return this.$store.state.boleto.boletovencido;
		},

		boletopago: function(){
			return this.$store.state.boleto.boletopago;
		},
		
	},

	methods:{
		retryOpenBoleto: function(){
			location.reload();
		}
	}

}
</script>


